import { Bell } from "lucide-react";
import { AnchoredMenu } from "@/components/ui/anchored-menu";
import { Badge } from "@/components/ui/badge";
import { useAuthStore } from "@/store/useAuthStore";
import { useNotificationsCount } from "@/hooks/useNotifications";
import { NotificationDropdown } from "./NotificationDropdown";

/**
 * D-043 S2 — live topbar bell (AC-001: real unread count, not hardcoded "3").
 *
 * badge = unread Notification count (stock notReadCount, 30s poll) — NOT the
 * Home/F6 action count. Flag react_notification_bell_enabled OFF → static
 * icon, no badge/dropdown (TZ §13 independent rollback).
 */
export function NotificationBell() {
  const enabled = useAuthStore((s) => s.featureFlags?.reactNotificationBell) ?? false;
  const { data: count } = useNotificationsCount(enabled);

  if (!enabled) {
    return (
      <span
        className="relative inline-flex h-9 w-9 items-center justify-center rounded-md"
        aria-label="Сповіщення"
      >
        <Bell className="h-[18px] w-[18px] text-muted-foreground" />
      </span>
    );
  }

  const unread = count ?? 0;

  return (
    <AnchoredMenu
      align="end"
      role="dialog"
      menuLabel="Сповіщення"
      className="overflow-hidden p-0"
      trigger={({ open, toggle }) => (
        <button
          type="button"
          onClick={toggle}
          aria-haspopup="dialog"
          aria-expanded={open}
          className="relative inline-flex h-9 w-9 items-center justify-center rounded-md transition-colors hover:bg-accent"
          aria-label={unread > 0 ? `Сповіщення: ${unread} непрочитаних` : "Сповіщення"}
          data-testid="notification-bell"
        >
          <Bell className="h-[18px] w-[18px] text-muted-foreground" />
          {unread > 0 && (
            <Badge
              variant="destructive"
              className="absolute right-0.5 top-0.5 h-[18px] min-w-[18px] justify-center px-1 text-[11px] tabular-nums"
              data-testid="notification-bell-badge"
            >
              {unread > 99 ? "99+" : unread}
            </Badge>
          )}
        </button>
      )}
    >
      {({ close }) => (
        <NotificationDropdown open unreadCount={unread} onClose={close} />
      )}
    </AnchoredMenu>
  );
}
